import { useState, useEffect } from 'react';

function getLocalStorageOrDefault(key, defaultValue) {
    const stored = localStorage.getItem(key);
    if (!stored) {
      localStorage.setItem(key, JSON.stringify(defaultValue));
      return defaultValue;
    }
    return JSON.parse(stored);
  }
  
  /**
   * @param {string} key key of localStorage
   * @param {any} defaultValue [default: "0"] default value of localStorage, will convert to string later
   * @returns {Array} [localStorage.getItem, localStorage.setItem]
   */
  export function useLocalStorage(key, defaultValue = "0") {
    const [value, setValue] = useState(
      getLocalStorageOrDefault(key, defaultValue)
    );
  
    useEffect(() => {
      localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);
  
    return [value, setValue];
  }